import { useSignupPageUpdate } from '@/services/onboardingService'
import { DeviceWidth, useIsDeviceWidth } from '@/utils/deviceWidthHelpers'
import { SIGNUP_PATHS } from '../helpers'
import { TypographyStyles } from '@/styles'
import { Button, Card, CardColors, Image, List, Text } from '@/ui'

export const JourneySelection = ({
  value,
  imageUrl,
  imageAlt,
  title,
  subtitle,
  selection,
  setSelection,
  recs,
}: {
  value: string
  imageUrl: string
  imageAlt: string
  title: string
  subtitle: string
  selection: string | undefined
  setSelection: (val: string) => void
  recs: string[]
}) => {
  const selected = selection === value
  const isMobile = useIsDeviceWidth(DeviceWidth.mobile)
  useSignupPageUpdate(SIGNUP_PATHS.practiceJourney)

  return (
    <Card
      color={CardColors.LEVEL_1}
      className="flex min-h-[620px] pt-6 px-10 flex-col gap-6"
    >
      <div className="flex justify-center mt-6 ">
        <Image src={imageUrl} className="h-[200px]" alt={imageAlt} />
      </div>

      <Text variant={TypographyStyles.H2} className="text-center">
        {title}
      </Text>

      <Text variant={TypographyStyles.H3} className="text-center">
        {subtitle}
      </Text>

      <Text variant={TypographyStyles.BODY_SM}>You have:</Text>

      <List className="my-0 list-disc mt-[-1em]">
        {recs.map((rec) => (
          <List.Item key={rec} className="ml-2">
            <Text variant={TypographyStyles.BODY_SM}>{rec}</Text>
          </List.Item>
        ))}
      </List>

      {!isMobile && <div className="flex-1" />}

      <Button
        variant={selected ? 'primary' : 'secondary'}
        onClick={() => setSelection(value)}
      >
        {selected ? 'Selected' : 'Select'}
      </Button>
    </Card>
  )
}
